import { Component, OnInit } from '@angular/core';
import { Todos } from '../models/todos';
import { Users } from '../models/users';
import { HttpService } from '../services/json.service';

@Component({
  selector: 'app-api-connection',
  templateUrl: './api-connection.component.html',
  styleUrls: ['./api-connection.component.css']
})
export class ApiConnectionComponent implements OnInit {

  users: Users[];

  loading: boolean = false;

  constructor(private httpService : HttpService) { }

  ngOnInit(): void {
    this.getDataFromAPI();
  }

  public getDataFromAPI(){
    this.loading = true;
    this.httpService.getItems('users/').subscribe(
      (response) => {
        console.log(response);
        this.users = response;
        this.loading = false;
      }, 
      (error) => {
        console.error(error);
        console.log('Failed request');
        this.loading = false;
      }
    )
  }

}
